import React from 'react'

const ImageRow = ({ data, isFrontPage }) => {
    const { topContent, bottomContent, imageBlock } = data

    let isHome = null;

    if (isFrontPage === true) {
        isHome = 'is-home'
    }

    return (
        <section className="image-row">
            {topContent && (topContent?.title || topContent?.content) && (
                <div className="top-content">
                    {topContent.title && (
                        <h5>{topContent.title}</h5>
                    )}
                    {topContent.content && (
                        <div dangerouslySetInnerHTML={{ __html: topContent.content }}></div>
                    )}
                </div>
            )}
            <div className={`image-blocks ${isHome}`}>
                { imageBlock ? imageBlock.map((block, i) => {
                    let tileCount = '';
                    const imageSize = block?.imageSize ? block?.imageSize : 100;
                    if (imageBlock.length === 4) {
                        tileCount = 'four'
                    }
                    return (
                        <div key={i} className={'image-tile ' + `${tileCount}`}>
                            <img style={{maxWidth: `${imageSize}%`}}
                                src={block.image?.localFile?.childImageSharp?.fluid?.src}
                            />
                            {block.title && (
                                <h5>{block.title}</h5>
                            )}
                            {block.content && (
                                <p>{block.content}</p>
                            )}
                            {block.button && (
                                <a className="btn button-solid" href={block.button.url}>{block.button.title}</a>
                            )}
                        </div>
                    )
                }) : null }
            </div>
            {bottomContent && (
                <div className="bottom-content">
                    {bottomContent.content && (
                        <div dangerouslySetInnerHTML={{ __html: bottomContent.content }}></div>
                    )}
                    {bottomContent.title && (
                        <h6>{bottomContent.title}</h6>
                    )}
                </div>
            )}
        </section>
    )
}

export default ImageRow
